/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { BONUS_TYPES, RESERVE_TYPES } from 'constants'

export const BONUS_TYPE_MESSAGES = {
    [BONUS_TYPES.EXTRA_CREDITS]: (
        <FormattedMessage
            id='construct_reserve_popover.bonus_types.extra_credits_title'
            defaultMessage='Дополнительные кредиты'
        />
    ),
    [BONUS_TYPES.EXTRA_FREE_XP]: (
        <FormattedMessage
            id='construct_reserve_popover.bonus_types.extra_free_xp_title'
            defaultMessage='Дополнительный свободный опыт'
        />
    ),
    [BONUS_TYPES.EXTRA_BATTLE_XP]: (
        <FormattedMessage
            id='construct_reserve_popover.bonus_types.extra_battle_xp_title'
            defaultMessage='Дополнительный боевой опыт'
        />
    ),
    [BONUS_TYPES.EXTRA_CREW_XP]: (
        <FormattedMessage
            id='construct_reserve_popover.bonus_types.extra_crew_xp_title'
            defaultMessage='Дополнительный опыт экипажа'
        />
    ),
}

export const EXTRA_DESCRIPTIONS = {
    [RESERVE_TYPES.AIRSTRIKE]: (
        <FormattedMessage
            id='construct_reserve_popover.extra_descriptions.airstrike'
            defaultMessage='При вызове авиаудара'
        />
    ),
    [RESERVE_TYPES.ARTILLERY_STRIKE]: (
        <FormattedMessage
            id='construct_reserve_popover.extra_descriptions.artillery_strike'
            defaultMessage='В Вылазках и при Наступлениях  на 1 бой'
        />
    ),
    [RESERVE_TYPES.INSPIRATION]: (
        <FormattedMessage
            id='construct_reserve_popover.extra_descriptions.inspiration'
            defaultMessage='В Вылазках и при Наступлениях'
        />
    ),
}

export const HEADERS = {
    SINGLE_USAGE: (
        <FormattedMessage
            id='construct_reserve_popover.single_usage_title'
            defaultMessage='Дополнительный промресурс на 1 бой'
        />
    ),
    [RESERVE_TYPES.REQUISITION]: (
        <FormattedMessage
            id='construct_reserve_popover.requisition_usage_title'
            defaultMessage='Дополнительный промресурс на 1 Наступление'
        />
    ),
    [RESERVE_TYPES.INSPIRATION]: (
        <FormattedMessage
            id='construct_reserve_popover.inspiration_usage_title'
            defaultMessage='Воодушевление на 1 бой'
        />
    ),
    [RESERVE_TYPES.ARTILLERY_STRIKE]: (
        <FormattedMessage
            id='construct_reserve_popover.art_usage_title'
            defaultMessage='Артобстрел'
        />
    ),
}

export const ALL_RESULTS_MESSAGE = (
    <FormattedMessage
        id='construct_reserve_popover.all_results'
        defaultMessage='Для всех результатов'
    />
)

export const WINS_ONLY_MESSAGE = (
    <FormattedMessage
        id='construct_reserve_popover.only_wins'
        defaultMessage='Только для побед'
    />
)



// WEBPACK FOOTER //
// ./containers/Construct/components/ConstructReserveTooltip/constants.jsx